import { ProductSliderStyleTokens } from "@omni/ui/brand/product/productSlider/productSlider.tokens";
import { UIProductSlider } from "@omni/ui/components/Product/ProductSlider/productSlider.styles";
import { tv } from "tailwind-variants";

export const ProductSliderStyles: ProductSliderStyleTokens = {
    navButtonColor: "gray"
};

export const productSlider = tv({
    extend: UIProductSlider,
    slots: {
        slider_navButton:
            "tw:text-xl! tw:text-secondary! tw:p-0 tw:rounded-full tw:min-h-8 tw:min-w-8 tw:justify-center tw:items-center tw:hidden tw:md:flex tw:hover:bg-grey-light! tw:focus:bg-grey-light!",
        slider_navButton_icon: "las",
        slider_slides: "tw:w-full tw:grow tw:mx-6",
        slider_slides_swiperslide: ""
    },
    variants: {
        type: {
            left: {
                slider_navButton_icon: "la-arrow-left"
            },
            right: {
                slider_navButton_icon: "la-arrow-right"
            }
        },
        skeleton: {
            true: {
                slider_slides_swiperslide: "tw:rounded-xl"
            }
        }
    }
});
